import { API_BASE_URL, handleResponse, getAuthHeader } from '../api';

export const sets = {
  getAll: async () => {
    const headers = await getAuthHeader('GET');
    const response = await fetch(`${API_BASE_URL}/sets`, {
      headers,
      credentials: 'include'
    });
    return handleResponse(response);
  },

  get: async (id) => {
    if (!id || typeof id === 'undefined') {
      throw new Error('Set ID is required');
    }
    const headers = await getAuthHeader('GET');
    const response = await fetch(`${API_BASE_URL}/sets/${id}`, {
      headers,
      credentials: 'include'
    });
    return handleResponse(response);
  },

  create: async (data) => {
    const headers = await getAuthHeader('POST');
    const response = await fetch(`${API_BASE_URL}/sets`, {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
      credentials: 'include'
    });
    return handleResponse(response);
  },

  delete: async (id) => {
    const headers = await getAuthHeader('DELETE');
    const response = await fetch(`${API_BASE_URL}/sets/${id}`, {
      method: 'DELETE',
      headers,
      credentials: 'include'
    });
    return handleResponse(response);
  },

  getSharedSet: async (shareId) => {
    const headers = await getAuthHeader('GET');
    const response = await fetch(`${API_BASE_URL}/sets/shared/${shareId}?include=owner`, {
      headers,
      credentials: 'include'
    });
    return handleResponse(response);
  },

  createShare: async (setId) => {
    const headers = await getAuthHeader('POST');
    const response = await fetch(`${API_BASE_URL}/sets/${setId}/share`, {
      method: 'POST',
      headers,
      credentials: 'include'
    });
    return handleResponse(response, 'POST');
  },

  deleteShare: async (setId) => {
    const headers = await getAuthHeader('DELETE');
    const response = await fetch(`${API_BASE_URL}/sets/${setId}/share`, {
      method: 'DELETE',
      headers,
      credentials: 'include'
    });
    return handleResponse(response, 'DELETE');
  },

  addCoins: async (setId, coinIds) => {
    const headers = await getAuthHeader('POST');
    const response = await fetch(`${API_BASE_URL}/sets/${setId}/coins`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ coinIds }),
      credentials: 'include'
    });
    return handleResponse(response, 'POST');
  },

  removeCoins: async (setId, coinIds) => {
    const headers = await getAuthHeader('DELETE');
    const response = await fetch(`${API_BASE_URL}/sets/${setId}/coins`, {
      method: 'DELETE',
      headers,
      body: JSON.stringify({ coinIds }),
      credentials: 'include'
    });
    return handleResponse(response, 'DELETE');
  },

  update: async (id, data) => {
    const headers = await getAuthHeader('PUT');
    const response = await fetch(`${API_BASE_URL}/sets/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(data),
      credentials: 'include'
    });
    return handleResponse(response);
  },

  updateCover: async (setId, imagePath) => {
    const headers = await getAuthHeader('PUT');
    const response = await fetch(`${API_BASE_URL}/sets/${setId}/cover`, {
      method: 'PUT',
      headers,
      body: JSON.stringify({ imagePath }),
      credentials: 'include'
    });
    return handleResponse(response, 'PUT');
  },

  updateSortPreferences: async (setId, sortPreferences) => {
    const headers = await getAuthHeader('PUT');
    const response = await fetch(`${API_BASE_URL}/sets/${setId}/sort`, {
      method: 'PUT',
      headers,
      body: JSON.stringify({ sort_preferences: sortPreferences }),
      credentials: 'include'
    });
    return handleResponse(response, 'PUT');
  },
};
